
/**
 * Query key constants for React Query
 * 
 * This helps maintain consistent query keys across the application
 */
export const QueryKeys = {
  // Enrollment related queries
  enrollments: (userId?: string) => ['enrollments', userId],
  
  // Course related queries
  courseProgress: (userId?: string) => ['courseProgress', userId],
  courseDetails: (courseId?: string) => ['courseDetails', courseId],
  
  // Lesson related queries
  lessonCompletions: (courseId?: string) => ['lessonCompletions', courseId],
  
  // User related queries
  currentUser: () => ['currentUser'],
};
